module.exports = __webpack_public_path__ + "img/堅持_四方連續_彩稿.d057ba66.png";